import { useMemo } from "react";

export const useSocialNetworksTexts = (text) => {
	return useMemo(
		() => ({
			discord: text.SOCIAL_NETWORKS.DISCORD,
			telegram: text.SOCIAL_NETWORKS.TELEGRAM,
			ok: text.SOCIAL_NETWORKS.OK,
			skype: text.SOCIAL_NETWORKS.SKYPE,
			snapchat: text.SOCIAL_NETWORKS.SNAPCHAT,
			tiktok: text.SOCIAL_NETWORKS.TIKTOK,
			viber: text.SOCIAL_NETWORKS.VIBER,
			vk: text.SOCIAL_NETWORKS.VK,
			whatsapp: text.SOCIAL_NETWORKS.WHATSAPP,
			youtube: text.SOCIAL_NETWORKS.YOUTUBE,
		}),
		[text]
	);
};
